import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { T } from '../traks';
import SearchField from '../c/SearchField';
import { PublicPortfolio } from '../c/Portfolio';

const G = (props) => props.children;

var ExploreCRYPTO = (props) => {
	var sections = [];

	sections.push(
		<Container key="this_is_the_unique_key_for_the_crypto_portfolio_container" className="pb-5 pt-5">
			<Row key="this_is_the_unique_key_for_the_crypto_portfolio_row" className="ad_notification_box">
				<Col md="12">
					<PublicPortfolio show_title={false} include_chart={false} portfolio_id={233}/>
				</Col>
			</Row>
		</Container>
	);

	const placeholder = <T>Search crypto-currencies</T>;

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_crypto justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Crypto currencies</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore various crypto currencies</T></div>
				<SearchField placeholder={placeholder} market="CRYPTOCURRENCIES" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

export default ExploreCRYPTO;



// WEBPACK FOOTER //
// ./src/p/ExploreCRYPTO.js